import { BehaviorSubject } from 'rxjs';
var showDialog = new BehaviorSubject(false);
export function observeScanDialog() {
    return showDialog.asObservable();
}
export function showScanDialog() {
    showDialog.next(true);
}
export function closeScanDialog() {
    showDialog.next(false);
}
//# sourceMappingURL=ScanDialogService.js.map